// @ts-expect-error
import tinycolor from 'tinycolor2';

/* TODO move to uikit */
/** same defaults as .cmps-cdk-bg-gradient-* */
export function bgGradient(opts: {
    color: string;
    lighten1?: number;
    lighten2?: number;
    angle?: number;
}): string | null {
    if (opts?.color == null || opts?.color.trim().length === 0) {
        return null;
    }
    const light1: string = tinycolor(opts.color)
        .lighten(opts.lighten1 ?? 15)
        .toRgbString();
    const light2: string = tinycolor(opts.color)
        .lighten(opts.lighten2 ?? 30)
        .toRgbString();
    return `linear-gradient(${opts.angle ?? 0}deg, ${
        opts.color
    } 0%, ${light1} 50%, ${light2} 100%)`;
}
